import type { SVGProps } from "react";

export default function SolarForbiddenCircleLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" d="M18.5 5.5L5.50002 18.4998"/><circle cx="12" cy="12" r="10"/></g></svg>
  );
}
